module.exports = __webpack_public_path__ + "img/jingdian.17b889fb.png";